import { axiosInstance } from "@/api/apiClient";
import {
  TagsApi,
  TagsApiUsersViewsNinjaTagsListTagsForBusinessRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new TagsApi(undefined, BASE_API, axiosInstance);

export const getTagsForBusiness = async (
  payload: TagsApiUsersViewsNinjaTagsListTagsForBusinessRequest
) => {
  return api.usersViewsNinjaTagsListTagsForBusiness.bind(api)(payload);
};
